import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IktatgatoService } from '../iktatgato.service';
import { DataService } from '../../data.service';

/**
 *  Érkeztetés: minden beérkező küldemény, még iktatás előtt.
 *
 *  Az adatkör a POSZEIDON érkeztetőlapját követi: a beküldő és a címzett is
 *  SZERVEZET + SZEMÉLY párban áll, nem egyetlen szabad szöveges mezőben. Így a
 *  küldemény visszakereshető marad akkor is, ha a feladó nevét háromféleképpen írták le.
 *
 *  A BKSZ-ről (hivatali kapu, cégkapu) letöltött üzenetek is ide kerülnek – a
 *  duplikálást a szerver zárja ki, ezért a behúzás bármikor újrafuttatható.
 */
@Component({
  selector: 'app-ikt-erkeztetes',
  templateUrl: './erkeztetes.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktErkeztetesComponent implements OnInit {
  ev = new Date().getFullYear();
  csakNyitott = true;
  sorok: any[] = [];
  betoltes = false;

  ujForm = false;
  ful: 'kuldemeny' | 'kulcsszavak' = 'kuldemeny';
  uj: any = {};

  szervezetek: any[] = [];
  szemelyek: any[] = [];

  hivataliNyitva = false;
  hivataliFolyamatban = false;

  readonly MODOK = [
    { kulcs: 'papir', nev: 'papír' },
    { kulcs: 'elektronikus', nev: 'elektronikus' },
    { kulcs: 'email', nev: 'e-mail' },
    { kulcs: 'bksz', nev: 'BKSZ (hivatali kapu / cégkapu)' },
    { kulcs: 'szemelyes', nev: 'személyes' },
    { kulcs: 'fax', nev: 'fax' },
  ];
  readonly PRIORITASOK = ['normál', 'sürgős', 'azonnal'];

  constructor(private ikt: IktatgatoService, private data: DataService, private router: Router) {}

  async ngOnInit() {
    this.urlapUrites();
    await this.betolt();
    try {
      const mind = await this.ikt.partnertorzs({});
      this.szervezetek = mind.filter((p: any) => p.tipus !== 'szemely');
      this.szemelyek = mind.filter((p: any) => p.tipus === 'szemely');
      // Az intézmény saját szervezete a magától értetődő belső címzett.
      const sajat = this.szervezetek.find((p: any) => p.belso);
      if (sajat) { this.uj.cimzett_szervezet = sajat.id; this.uj.belso_cimzett_szervezet = sajat.id; }
    } catch { this.szervezetek = []; this.szemelyek = []; }
  }

  private most() {
    const d = new Date();
    const p = (n: number) => String(n).padStart(2, '0');
    return {
      nap: `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`,
      perc: `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`,
    };
  }

  urlapUrites() {
    const m = this.most();
    this.uj = {
      erkezett: m.nap, feladas_ideje: m.perc, erkezes_mod: 'papir', adathordozo: 'papir',
      azonosito: '', targy: '', kuldo_nev: '', kuldo_cim: '', bekuldo_email: '',
      bekuldo_szervezet: '', bekuldo_szemely: '',
      cimzett_szervezet: this.uj?.cimzett_szervezet || '', cimzett_szemely: '',
      belso_cimzett_szervezet: this.uj?.belso_cimzett_szervezet || '', csak_belso_szemelyek: false,
      erkezteto_konyv: 'kozponti', prioritas: '',
      elektronikus_visszaigazolas: false, nem_iktatando: false, serult: false, digitalis: false,
      felbontatlan: false, sk_felbontas: false, kulcsszavak: '', feljegyzes: '', megjegyzes: '',
    };
  }

  async betolt() {
    this.betoltes = true;
    try { this.sorok = await this.ikt.erkeztetesek(this.ev, this.csakNyitott); }
    catch (e: any) { this.data.sendToast(e?.error?.error || 'Nem sikerült betölteni az érkeztetést.', 'error'); }
    finally { this.betoltes = false; }
  }

  /** A beküldő neve a partnerválasztásból, ha nem gépeltek be mást. */
  bekuldoValt() {
    if (this.uj.kuldo_nev) return;
    const p = this.szemelyek.find((x) => x.id === this.uj.bekuldo_szemely)
      || this.szervezetek.find((x) => x.id === this.uj.bekuldo_szervezet);
    if (p) {
      this.uj.kuldo_nev = p.nev;
      this.uj.kuldo_cim = [p.irsz, p.telepules, p.cim].filter(Boolean).join(' ');
      if (!this.uj.bekuldo_email) this.uj.bekuldo_email = p.email || '';
    }
  }

  /** Az elektronikus érkezési módoknál a digitális jelölő magától értetődik. */
  modValt() {
    this.uj.digitalis = ['elektronikus', 'email', 'bksz'].includes(this.uj.erkezes_mod);
    if (this.uj.digitalis) this.uj.adathordozo = 'elektronikus';
  }

  async rogzit() {
    if (!this.uj.targy && !this.uj.kuldo_nev && !this.uj.bekuldo_szervezet && !this.uj.bekuldo_szemely) {
      this.data.sendToast('Adj meg legalább beküldőt vagy tárgyat.', 'warning');
      return;
    }
    try {
      const r = await this.ikt.erkeztet(this.uj);
      this.data.sendToast(`Érkeztetve: ${r.sorszam}/${r.ev}.`);
      this.ujForm = false;
      this.urlapUrites();
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az érkeztetés nem sikerült.', 'error');
    }
  }

  /** BKSZ-behúzás – a hivatali kapu postafiókja a BKSZ gépi interfészén (háttérben fut). */
  hivataliAllapot = '';
  async hivataliKapu() {
    this.hivataliFolyamatban = true;
    this.hivataliAllapot = '';
    try {
      await this.ikt.bejovoSzinkron();
      let s: any = { fut: true };
      while (s?.fut) {
        await new Promise((r) => setTimeout(r, 2000));
        s = await this.ikt.bejovoStatusz();
        if (s?.fut) this.hivataliAllapot = `Letöltés… ${s.letoltve || 0} tétel`;
      }
      const hibas = (s?.hibak || []).length;
      this.data.sendToast(s?.uzenet || 'A letöltés befejeződött.', hibas ? 'warning' : (s?.uj ? 'success' : 'info'));
      this.hivataliNyitva = false;
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A BKSZ-letöltés nem sikerült.', 'error');
    } finally {
      this.hivataliFolyamatban = false;
      this.hivataliAllapot = '';
    }
  }

  /** Iktatás: az érkeztetési sor adatait átvisszük az iktató űrlapra. */
  iktat(sor: any) {
    if (sor.nem_iktatando) {
      this.data.sendToast('Ez a küldemény „nem iktatandó" jelölést kapott.', 'warning');
      return;
    }
    this.router.navigate(['/iktatgato/iktatas'], {
      queryParams: {
        erkeztetes: sor.id, targy: sor.targy || '', partner: sor.kuldo_nev || '',
        adathordozo: sor.adathordozo, partner_id: sor.bekuldo_szemely || sor.bekuldo_szervezet || '',
        digitalis: sor.digitalis ? 1 : '',
      },
    });
  }
}
